import {environment} from '@env/environment';

const url = environment.api.url;

export const Constants = {
    assets: {
        logo: 'assets/images/logo.png',
        user: 'assets/images/user-placeholder.png',
        empty: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    },
    regex: {
        slug: /^[a-z][a-z\-]*[a-z]$/,
        email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        price: /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/,
        integer: /^[0-9]+$/
    },
    endpoints: {
        login: `${url}/auth/login`,
        register: `${url}/auth/register`,
        logout: `${url}/auth/logout`,
        request: `${url}/auth/reset`,
        reset: `${url}/auth/reset-password`,
        refresh: `${url}/auth/refresh`,
        me: `${url}/auth/me`,
        avatar: `${url}/auth/avatar`,
        platforms: `${url}/platforms`,
        users: `${url}/users`,
        prices: `${url}/prices`,
        videos: `${url}/videos`,
        feeds: `${url}/feeds`,
        livestreams: `${url}/live`,
        sections: `${url}/sections`,
        currencies: `${url}/currencies`,
        subscription: `${url}/payments/subscription`,
        subscriptionMonthly: `${url}/payments/subscription-monthly`,
        subscriptionOneOff: `${url}/payments/subscription-oneoff`,
        downloadInvoices: `${url}/invoices/download`,
        paymentMethods: `${url}/payments/methods`
    }
};
